// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"0c989746","43":"3727b762","137":"02600cc2","282":"bbb5cecc","353":"ad97964d","566":"4ce31dff","799":"e6079810","892":"cbc10e4b","950":"78ccf31c"}[chunkId] + ".chunk.js";
};